import { render, staticRenderFns } from "./default-specs.app.vue?vue&type=template&id=f828b008&"
import script from "./default-specs.app.vue?vue&type=script&lang=js&"
export * from "./default-specs.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports